import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


import Swal from "sweetalert2";
import { useNavigate, Link } from "react-router-dom"; // Import useNavigate

const AddTyre = () => {
  useAuthRedirect();
  const navigate = useNavigate(); // Initialize navigate function
  const [branches, setbranches] = useState([]);
  const userName = localStorage.getItem("username"); // Default branch from storage
    // const [selectedBranch, setSelectedBranch] = useState(storedBranch || "");
 const [formData, setFormData] = useState({
  tyre_seriolno : "",
  	tyre_model	: "",
    tyre_make : "",
    tyre_amount	: "",
    tyre_type	 : "",
    tyre_position	: "",
    branch	: "",
    purchased_date: "",
    tyre_enterdate: "",
    tyre_remove	: "No",
    purchased_from: "",
    userid : ""
 
   });

    const canEntry = hasPermission("Tyre Details", "entry");

   useEffect(() => {
    axios.get("https://rfs2.infraconsoft.net.in/api/get_branches")
      .then((response) => {
        setbranches(response.data.branches);
      })
      .catch((error) => {
        console.error("Error fetching branches:", error);
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    console.log("Form Submit Triggered");
    console.log("Form Data:", formData);
  
    // Step 1: Define  fields
    const Fields = [
      { key: "tyre_seriolno", label: "Tyre Serial No" },
      { key: "tyre_model", label: "Tyre Model" },
      { key: "tyre_make", label: "Tyre Make" },
      { key: "tyre_amount", label: "Tyre Amount" },
      { key: "tyre_type", label: "Tyre Type" },
      { key: "tyre_position", label: "Tyre Position" },
      { key: "branch", label: "Branch" },
      { key: "purchased_date", label: "Purchased Date" },
      { key: "tyre_enterdate", label: "Enter Date" },
      { key: "tyre_remove", label: "Remove Status" },
      { key: "purchased_from", label: "Purchased From" }
    ];
  
    // Step 2: Validation Loop
    for (const field of Fields) {
      const value = formData[field.key];
      if (!value || value.toString().trim() === "") {
        await Swal.fire({
          icon: "warning",
          title: "Missing Field",
          text: `Please enter ${field.label}`,
          width: "400px"
        });
        return; // Stop submission if validation fails
      }
    }
  
    try {
      Swal.fire({
        title: "Submitting...",
        text: "Please wait while we process your request.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
  
      const payload = {
        tyre_seriolno: formData.tyre_seriolno,
        tyre_model: formData.tyre_model,
        tyre_make: formData.tyre_make,
        tyre_amount: formData.tyre_amount,
        tyre_type: formData.tyre_type,
        tyre_position: formData.tyre_position,
        branch: formData.branch,
        purchased_date: formData.purchased_date,
        tyre_enterdate: formData.tyre_enterdate,
        tyre_remove: formData.tyre_remove,
        purchased_from: formData.purchased_from,
        userid: userName
      };
  
      console.log("Payload being sent to server:", payload);
  
      const response = await axios.post(`https://rfs2.infraconsoft.net.in/api/add_tyre_api`, payload);
  
      console.log("Server response:", response.data);
  
      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Inserted!",
          text: "Tyre inserted successfully.",
        });
        navigate("/tyrelisting");
      } else {
        console.warn("Insert failed, no 'success' in response:", response.data);
        Swal.fire({
          icon: "error",
          title: "Insert Failed",
          text: response.data.message || "Unknown error.",
        });
      }
  
    } catch (error) {
  console.error("Error inserting tyre:", error);

  if (error.response && error.response.data && error.response.data.message) {
    // Show backend validation error (like duplicate tyre_seriolno)
    Swal.fire({
      icon: "error",
      title: "Insert Failed",
      text: error.response.data.message,
    });
  } else {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Insert failed. Please try again.",
    });
  }
}

  };
   
  if (!canEntry) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  


  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          
        <div className="back-div">
          <h2 className="add-txt">Add New Tyre</h2>
          <Link to='/tyrelisting'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
        </div>
         
          <div>
            <Time />
          </div>
        </section>

        <div className="form-container">
        <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Serial No :</label>
                <input
                  type="text"
                  name="tyre_seriolno"
                  value={formData.tyre_seriolno}
                  onChange={handleChange}
                  
                />
              </div>
              <div className="form-group">
                <label>Entry Date:</label>
                <input
                  type="date"
                  name="tyre_enterdate"
                  value={formData.tyre_enterdate}
                  onChange={handleChange}
                  
                />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Tyre Model:</label>
                <input
                  type="text"
                  name="tyre_model"
                  value={formData.tyre_model}
                  onChange={handleChange}
                  
                />
              </div>
              <div className="form-group">
                <label>Branch:</label>
                <select name="branch"  value={formData.branch}   className="branch-select" onChange={handleChange} >
                    <option value="">-- Select Branch -- </option>
                    {branches.map((item) => (
                        <option key={item.branchMaster_code} value={item.branchMaster_code}>
                        {item.branchMaster_name}
                        </option>
              ))}
            </select>
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Tyre Make:</label>
                <input
                  type="text"
                  name="tyre_make"
                  value={formData.tyre_make}
                  onChange={handleChange}
                  
                />
              </div>
              <div className="form-group">
                <label>Tyre Type:</label>
                <select name="tyre_type"  value={formData.tyre_type}   className="branch-select"  onChange={handleChange} >
                <option value="">--- Select ---</option>
                <option value="new">New</option>
                <option value="retreated">Retreated</option>
            </select>
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Tyre Position:</label>
                <select  name="tyre_position"  value={formData.tyre_position}   className="branch-select" onChange={handleChange} >
                <option value="">--- Select ---</option>
                <option value="Front">Front</option>
                <option value="Rear">Rear</option>
            </select>
              </div>
              <div className="form-group">
                <label>Purchased Date:</label>
                <input
                  type="date"
                  name="purchased_date"
                  value={formData.purchased_date}
                  onChange={handleChange}
                  
                />
                  </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Purchased From:</label>
                <input
                  type="text"
                  name="purchased_from"
                  value={formData.purchased_from}
                  onChange={handleChange}
                  
                />
              </div>
              <div className="form-group">
                <label>Purchased Amount:</label>
                <input
                  type="text"
                  name="tyre_amount"
                  value={formData.tyre_amount}
                  onChange={handleChange}
                  
                />
                  </div>
            </div>
           
            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Submit
              </button>
            </div>
          </form>
        </div>
        
      </div>
    </div>
  );
};

export default AddTyre;
